/**
 * Where a saved chat was started. One person has one chat history across every surface (gyro-svc history.ts, owner
 * directive 2026-10-13), and each conversation gyro-svc lists carries `app`, the key of the surface it lives in. A chat
 * from another surface gets a small label in the list ("Desktop", "Office", "The Lab"); a chat of the current surface
 * gets none. The words are the ones people see for each surface elsewhere in the widget (the action card's system
 * names) and in gyro-svc (surfaceLabels.ts), except that the desktop app is "Desktop" here, not "This PC": the list is
 * read from another computer or a browser as often as from the PC the chat was started on.
 */
const ORIGIN_LABELS = {
    desktop: 'Desktop',
    office: 'Office',
    web: 'Gyro on the web',
    teams: 'Teams',
    'hub-web': 'The Hub',
    'hub-ios': 'The Hub',
    'hub-android': 'The Hub',
    'hub-submissions': 'The Hub',
    'the-lab': 'The Lab',
    nebula: 'Nebula',
    orbit: 'Orbit',
    bridge: 'The Bridge',
    'bridge-console': 'Bridge Console',
    'all-hands': 'All Hands',
    meridian: 'Meridian',
    'star-command': 'Star Command',
    'softdev-roadmap': 'Dev360 Roadmap',
    'server-monitor': 'Server Monitor',
    pulsar: 'Pulsar',
    'transmission-control': 'Transmission Control',
    uplink: 'Uplink',
    admin: 'Gyro Admin',
    demo: 'Demo',
};
/** What a surface key looks like on the wire: a lower-case slug (gyro-svc appCaller admits nothing else). */
const SURFACE_KEY = /^[a-z0-9][a-z0-9_-]{0,39}$/;
/**
 * The label for the surface a chat was started in, or undefined when it needs none: the chat lives in the current
 * app (`current`), or `app` is absent (an older gyro-svc that lists one app's chats only, or a chat this widget made).
 * A key the widget has no words for is title-cased ('new-host' becomes 'New Host'), so a host added tomorrow is still
 * named; anything that is not a surface key at all yields undefined rather than a label built from it.
 */
export function chatOriginLabel(app, current) {
    if (!app || app === current)
        return undefined;
    if (Object.hasOwn(ORIGIN_LABELS, app))
        return ORIGIN_LABELS[app];
    if (!SURFACE_KEY.test(app))
        return undefined;
    return app
        .split(/[-_]+/)
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');
}
//# sourceMappingURL=chatOrigin.js.map